import { useEffect } from "react";

const ScrollToTop = () => {
  useEffect(() => {
    // Scroll to top when component mounts (page loads/refreshes)
    window.scrollTo(0, 0);
  }, []); // Empty dependency array means it runs only once on mount

  return null;
};

export default ScrollToTop;